import React from "react";

const legalStyles = `
.legal-hero { background: linear-gradient(90deg,#0b5fa8 0%,#0d84d6 100%); color: #fff; padding: 18px 0; display:flex; align-items:center; justify-content:center; text-align:center; }
.legal-hero h1 { font-size: 1.5rem; margin: 0 0 6px; }
.legal-hero p { font-size: 1rem; margin: 0; opacity: 0.95; }
.legal-hero .legal-meta { margin-top: 8px; font-size: 12px; color: rgba(255,255,255,0.9); }
.legal-container { max-width: 820px; margin: 0 auto; padding: 20px 18px; }
.legal-card { background: #fff; border-radius: 8px; padding: 22px; box-shadow: 0 6px 24px rgba(12,22,38,0.06); }
.legal-card h2 { color: #0b5fa8; margin-bottom: 12px; font-size: 1.25rem; }
.legal-card h3 { color: #0f6fb2; margin-top: 14px; margin-bottom: 8px; }
.legal-card p { color: #374151; line-height: 1.7; margin-bottom: 12px; }
@media (max-width:640px) { .legal-hero { padding: 16px 0; } .legal-container { padding: 14px; } }
`;

const Disclaimer = () => {
  return (
    <div className="min-h-screen bg-gray-50 font-roboto text-gray-800">
      <style>{legalStyles}</style>
      {/* Hero Section */}
      <div className="legal-hero">
        <div className="container mx-auto px-4">
          <h1>Disclaimer</h1>
          <div className="legal-meta">Last updated: January 1, 2026</div>
        </div>
      </div>

      
      <div className="legal-container">
        <div className="legal-card">
          <h2 className="text-3xl font-bold mb-4">Disclaimer</h2>

          <section className="mb-8">
            <p className="mb-4 leading-relaxed">
              The Indian Bar Council prohibits law firms from advertising and
              soliciting work through communication in the public domain. This
              website is meant solely for the purpose of information and not for
              the purpose of advertising.
            </p>
            <p className="leading-relaxed">
              Lextria Research does not intend to solicit clients through this
              website. We do not take responsibility for the decisions taken by
              the reader based solely on the information provided on the
              website.
            </p>
          </section>

          <section className="mb-8">
            <h3 className="text-2xl font-bold text-blue-500 mb-4 border-b-2 border-blue-500 pb-2">
              Legal Disclaimer
            </h3>
            <p className="leading-relaxed">
              The information provided on this website is for general
              informational purposes only and does not constitute legal advice.
              Any information provided should not be considered a substitute for
              professional legal counsel. Lextria Research makes no warranties,
              expressed or implied, regarding the accuracy or completeness of
              the information.
            </p>
          </section>

          <section className="mb-8">
            <h3 className="text-2xl font-bold text-blue-500 mb-4 border-b-2 border-blue-500 pb-2">
              No Professional Relationship
            </h3>
            <p className="leading-relaxed">
              Accessing this website does not establish an attorney-client
              relationship. Any communications sent to or received from Lextria
              Research through this website are not confidential unless a formal
              engagement letter has been executed.
            </p>
          </section>

          <section className="mb-8">
            <h3 className="text-2xl font-bold text-blue-500 mb-4 border-b-2 border-blue-500 pb-2">
              Limitation of Liability
            </h3>
            <p className="leading-relaxed">
              Lextria Research shall not be liable for any direct, indirect,
              incidental, special, or consequential damages arising from the use
              or inability to use this website or the information provided
              herein, including but not limited to loss of profits, business
              interruption, or loss of data.
            </p>
          </section>

          <section className="mb-8">
            <h3 className="text-2xl font-bold text-blue-500 mb-4 border-b-2 border-blue-500 pb-2">
              Third-Party Links
            </h3>
            <p className="leading-relaxed">
              This website may contain links to third-party websites. Lextria
              Research is not responsible for the content, accuracy, or
              practices of these external sites. Use of third-party links is at
              your own risk.
            </p>
          </section>

          <section className="mb-8">
            <h3 className="text-2xl font-bold text-blue-500 mb-4 border-b-2 border-blue-500 pb-2">
              Intellectual Property
            </h3>
            <p className="leading-relaxed">
              All content on this website, including text, images, logos, and
              other materials, is protected by copyright and intellectual
              property laws. Reproduction or distribution without permission is
              prohibited.
            </p>
          </section>

          <section className="mb-8">
            <h3 className="text-2xl font-bold text-blue-500 mb-4 border-b-2 border-blue-500 pb-2">
              Disclaimer of Warranties
            </h3>
            <p className="leading-relaxed">
              This website is provided on an "as-is" basis without any
              warranties, either expressed or implied. Lextria Research does not
              warrant that the website will be uninterrupted, error-free, or
              free from viruses or harmful components.
            </p>
          </section>

          <section className="mb-8">
            <h3 className="text-2xl font-bold text-blue-500 mb-4 border-b-2 border-blue-500 pb-2">
              Contact Information
            </h3>
            <p className="leading-relaxed">
              For questions or concerns regarding this disclaimer, please
              contact us at
              <a
                href="mailto:info@lextria.in"
                className="text-blue-600 hover:text-blue-800 hover:underline ml-1"
              >
                info@lextria.in
              </a>
              .
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Disclaimer;
